import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { message } from 'antd';
import { useParams } from 'react-router-dom';
import { updateAppVersion, addAppVersion } from '../../actions';
import {
  validateAppVersionsOnChange,
  validateAppVersion,
  validateDiscountOnChange,
  validateDiscount
} from '../../validators';
import {
  createSellerDiscount,
  deleteSellerDiscount,
  fetchDeliveryOptionsList,
  fetchDiscountList
} from '../../actions/discount';
import {
  getSellerDetailsById,
  uploadMultipleDishes
} from '../../actions/chefsandrestaurants';
import { SOCKET_URL_ENDPOINT } from '../../constants';
import { saveAs } from 'file-saver';

export const addRemoveSellerDiscountHook = () => {
  const params = useParams();
  let sellerId = params.id;
  let sellerType = params.name;
  const datMapping = {
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
    Sunday: 7
  };

  const initialSellerDiscountData = {
    seller_id: params.id,
    discount_id: '',
    delivery_option_id: '',
    expire_at: '',
    status: true
  };
  // const [discountData, setDiscountData] = useState(initialDiscountData)
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});
  const [deleteDiscountData, setDeleteDiscountData] = useState({});
  const [sellerDiscountData, setSellerDiscountData] = useState({});
  const [showAddSellerDiscountModal, setShowAddSellerDiscountModal] = useState(
    false
  );
  const [
    showDeleteSellerDiscountModal,
    setShowDeleteSellerDiscountModal
  ] = useState(false);
  const [formData, setFormData] = useState({
    deliveryOptions: [],
    discountList: []
  });
  const [sellerdet, setSellerDet] = useState([]);
  const [sellercuisins, setSellerCuisins] = useState([]);
  const [deliveryopt, setDeliveryopt] = useState([]);
  const [foodSellerAvailableTimes, setFoodSellerAvailableTimes] = useState([]);
  const [
    foodSellerAdditionalDiscounts,
    setFoodSellerAdditionalDiscounts
  ] = useState([]);
  const [statistics, setStatistics] = useState([]);
  const [msg, setMsg] = useState('');
  const [msgstatus, setMsgStatus] = useState('');
  const [uploadFileData, setUploadFileData] = useState({});
  const [loading, setLoading] = useState(false);
  const fileUrl =
    SOCKET_URL_ENDPOINT + '/public/assets/EF%20Multiple%20Items%20Add.xlsx';
  const fileRef = useRef(null);

  useEffect(() => {
    getFormDataList();
    fetchSellerData();
  }, []);

  const getFormDataList = async () => {
    try {
      const fetchDiscountListResp = await fetchDiscountList();
      const fetchDeliveryOptionsListResp = await fetchDeliveryOptionsList();
      const discountsResp = fetchDiscountListResp.data;
      const deliveryOptionResp = fetchDeliveryOptionsListResp.data;
      if (discountsResp.success) {
        console.log(discountsResp, '::discountsResp');
        const discountFilteredData = discountsResp.ResponseData.discounts.map(
          (discount, stateIndex) => {
            return {
              label: discount.title,
              value: discount.id,
              discount: discount.discount,
              is_percentage: discount.is_percentage
            };
          }
        );
        const deliveryOptions = deliveryOptionResp.ResponseData.map(
          (deliveryOption, stateIndex) => {
            return {
              label: deliveryOption.option_name,
              value: deliveryOption.option_id
            };
          }
        );
        setFormData({
          deliveryOptions: deliveryOptions,
          discountList: discountFilteredData
        });
      }

      // discount_id
      // delivery_option_id
      // seller_id
      // expire_at
      // status
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSellerData = async () => {
    try {
      const response = await getSellerDetailsById(sellerId);
      if (response && response.data) {
        setMsgStatus(response.data.status);
        setMsg(response.data.ResponseText);

        const sellerData = response.data.ResponseData || '';
        setSellerDet(sellerData);
        setSellerCuisins(sellerData.food_seller_cuisine_mappings);

        const availableTimes =
          sellerData.food_seller_available_days.filter(
            available_day => available_day.status
          ) || [];
        const sortedData = [...availableTimes].sort(
          (a, b) => datMapping[a.day_name] - datMapping[b.day_name]
        );

        setFoodSellerAvailableTimes(sortedData);
        setFoodSellerAdditionalDiscounts(sellerData.food_seller_discounts);

        setDeliveryopt(sellerData.food_seller_delivery_options);
        // setStatistics(response.data.details.statistics === null ? '' : response.data.details.statistics);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectChange = event => {
    const { name, value } = event.target;
    // const errors = validateDiscountOnChange(name, value, errorMessages)
    // setErrorMessages({ ...errors })
    setSellerDiscountData({
      ...sellerDiscountData,
      [name]: value
    });
  };

  const handleDateChange = event => {
    let frDate =
      event.getFullYear() +
      '-' +
      (event.getMonth() + 1) +
      '-' +
      event.getDate();
    setSellerDiscountData({
      ...sellerDiscountData,
      expire_at: frDate
    });
  };

  const handleSwitchChange = (selectedValue, name) => {
    // const errors = validateDiscountOnChange(name, selectedValue, errorMessages)
    // setErrorMessages({ ...errors })
    setSellerDiscountData({
      ...sellerDiscountData,
      [name]: selectedValue
    });
  };

  const toggleAddDiscountModal = () => {
    setSellerDiscountData(initialSellerDiscountData);
    setShowAddSellerDiscountModal(!showAddSellerDiscountModal);
  };

  const toggleDeleteDiscountModal = sellerDiscount => {
    if (sellerDiscount) {
      console.log(sellerDiscount, '::sellerDiscount');
      setDeleteDiscountData(sellerDiscount);
    }
    setShowDeleteSellerDiscountModal(!showDeleteSellerDiscountModal);
  };

  const handleDeleteSellerDiscount = async () => {
    console.log(deleteDiscountData, '::deleteDiscountData');

    setDeleteDiscountData(async discount => {
      setFoodSellerAdditionalDiscounts(prev => {
        const updatedDiscounts = prev.filter(disc => disc.id !== discount.id);
        console.log('SAIKIRAN::::', { updatedDiscounts });
        return updatedDiscounts;
      });
      const deleteDiscountResp = await deleteSellerDiscount(discount.id);
      const deleteDiscountData = deleteDiscountResp.data;
      if (deleteDiscountData.success) {
        toggleDeleteDiscountModal();
        // getDiscountList()
        // location.reload()
      }
      return discount;
    });
  };

  const handleSellerDiscountSubmit = async () => {
    try {
      // const errors = validateDiscount(discountData)
      // setErrorMessages(errors)
      // if (Object.keys(errors).length > 0) {
      //    return;
      // }

      // setIsLoading(true)
      let sellerDiscountResp;
      // if (discountData.id) {
      //    appVersionRes = await updateDiscount(discountData.id, discountData)
      // } else {

      sellerDiscountResp = await createSellerDiscount(sellerDiscountData);
      // }
      if (sellerDiscountResp.data.success) {
        // location.reload()
        toggleAddDiscountModal();
        setFoodSellerAdditionalDiscounts(prev => [
          ...prev,
          sellerDiscountResp.data.ResponseData
        ]);
        // setSellerDiscountData(prev => {
        //    prev.discount_id = ""
        //    prev.delivery_option_id = "";
        //    prev.expire_at = null;
        //    prev.status = false;
        //    return prev
        // });
        toast.success(sellerDiscountResp.ResponseText);
      }

      // setErrorMessages({});
      // getDiscountList()
      // setDiscountData(initialDiscountData)
    } catch (error) {
      console.log({
        error
      });
      toast.error('Something went wrong');
    } finally {
      setIsLoading(false);
    }
  };

  const downloadFile = async () => {
    try {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const blob = await response.blob();
      saveAs(blob, 'EF_Multiple_Items_Add.xlsx');
      toast.success('File downloaded successfully!');
    } catch (error) {
      console.error('Download error:', error);
      // message.error('Failed to download file');
    }
  };

  const handleFileUpload = async event => {
    try {
      console.log(event.target?.files);
      const file = event.target?.files[0];
      setUploadFileData({
        ...uploadFileData,
        file: file,
        name: file.name
      });
      if (fileRef.current) {
        fileRef.current.value = '';
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const handleFileSubmit = async () => {
    try {
      if (!uploadFileData.file) {
        toast.error('Please upload a file first');
        return;
      }
      setLoading(true);
      let formData = new FormData();
      formData.append('excel', uploadFileData?.file);
      formData.append('seller_id', sellerId);
      //  return;
      const fileResponse = await uploadMultipleDishes(formData);
      console.log(fileResponse);
      if (fileResponse?.status === 200) {
        toast.success(fileResponse?.data?.ResponseText);
        setLoading(false);
        setUploadFileData({});
      } else {
        toast.error(fileResponse?.data?.ResponseText);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.ResponseText);
    }
  };

  return {
    showAddSellerDiscountModal,
    showDeleteSellerDiscountModal,
    handleSellerDiscountSubmit,
    formData,
    sellerDiscountData,
    toggleAddDiscountModal,
    handleSwitchChange,
    handleSelectChange,
    handleDateChange,
    toggleDeleteDiscountModal,
    handleDeleteSellerDiscount,

    sellerdet,
    sellercuisins,
    deliveryopt,
    foodSellerAvailableTimes,
    foodSellerAdditionalDiscounts,
    statistics,
    msg,
    msgstatus,
    uploadFileData,
    loading,
    fileRef,
    downloadFile,
    handleFileUpload,
    handleFileSubmit
  };
};
